export default "__VITE_ASSET__Dx2zIcEM__"